// A controller to handle multi-step javascript driven screens.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "nextButton", "backButton", "submitButton"]

  connect() {
    this.currentIndex = 0
    this.showCurrentStep()
  }

  next(event) {
    event.preventDefault()
    if (!this.validCurrentStep()) return

    if (this.currentIndex < this.stepTargets.length - 1) {
      this.currentIndex++
      this.showCurrentStep()
    }
  }

  back(event) {
    event.preventDefault()
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.showCurrentStep()
    }
  }

  goToStep(index) {
    if (index >= 0 && index < this.stepTargets.length) {
      this.currentIndex = index
      this.showCurrentStep()
    }
  }

  reset() {
    this.currentIndex = 0
    this.showCurrentStep()
  }


  showCurrentStep() {
    this.stepTargets.forEach((el, i) =>
      el.classList.toggle("hidden", i !== this.currentIndex)
    )

    // Optional: disable/enable buttons
    if (this.hasBackButtonTarget) {
      this.backButtonTarget.disabled = this.currentIndex === 0
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle("hidden", this.currentIndex === this.stepTargets.length - 1)
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.toggle("hidden", this.currentIndex !== this.stepTargets.length - 1)
    }
  }

  validCurrentStep() {
    const currentStep = this.stepTargets[this.currentIndex]

    // Optional: look for data-required-check
    const requiredCheck = currentStep.querySelector("[data-required-check]")
    if (requiredCheck && !requiredCheck.checked) {
      requiredCheck.focus()
      return false
    }

    return true
  }
}
